import React from "react";
import styles from "./personalposts.module.css"; 

const EditComment = ({
  isOpen,
  onClose,
  onConfirm,
  commentContent,
  onChangeContent,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <h2>Edit Comment</h2>
        <textarea
          value={commentContent}
          onChange={(e) => onChangeContent(e.target.value)}
        />
        <div className={styles.buttons}>
          <button className={styles.button} onClick={onConfirm}>
            Confirm
          </button>
          <button className={styles.button} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditComment;
